export default [
  {
    path: "list",
    component: resolve => require(["../views/channel/list.vue"], resolve)
  },
  {
    path: "type",
    component: resolve => require(["../views/channel/type.vue"], resolve)
  }
];
